<template>
  <layout-default-appbar filterable :filters="filters">
    Prestação de Serviço
  </layout-default-appbar>
</template>

<script>
import LayoutDefaultAppbar from '@/layouts/default/AppBar.vue';
import { PRESTACAO_QUERIES } from '@/constants/QUERY_FILTERS';

export default {
  name: 'ViewPrestacoesDeServicoAppBar',

  components: {
    LayoutDefaultAppbar,
  },

  data() {
    return {

      filters: [
        PRESTACAO_QUERIES.createdFrom,
        PRESTACAO_QUERIES.createdBefore,
      ],
    };
  },
};
</script>
